import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Testimonial from '../components/sections/Testimonial';
import Cta from '../components/sections/Cta';
import Ban from '../components/sections/Ban';
import Cooperator from '../components/sections/cooperator';


const Home = () => {

  return (
    <>
      <Hero className="illustration-section-01" />
      <Ban/>
      <FeaturesTiles />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <Testimonial topDivider />
      <Cooperator/>
      <Cta center/>
    </>
  );
}

export default Home;